// src/current-identity.contract.ts
import { z } from "zod";
var CurrentIdentitySchema = z.object({
  userId: z.string().min(1),
  tenantId: z.string().uuid(),
  realm: z.string().min(1).optional()
});

export {
  CurrentIdentitySchema
};
//# sourceMappingURL=chunk-XXBHGVL4.js.map